/**
 * notificationSlice: 알림 카드 팝업 상태 관리
 * wehago-conference의 useNotiCard + local.notificationCardList 에서 리팩토링
 *
 * 카드 타입:
 * - REQUEST_INVITE: 회의 참석 요청 (대기실)
 * - REQUEST_FLOOR: 발언권 요청
 * - UPDATE_CHATTING: 새 채팅 메시지
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { NotiCardType, NotiCard } from '@/types/store';
import { toAbsoluteProfileUrl } from '@/utils/profileUtils';

// re-export for backwards compatibility
export type { NotiCardType, NotiCard } from '@/types/store';

export interface NotificationState {
  cards: NotiCard[];
}

const initialState: NotificationState = {
  cards: [],
};

let notiIdCounter = 0;

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addCard(state, action: PayloadAction<Omit<NotiCard, 'id' | 'timestamp'>>) {
      notiIdCounter += 1;
      state.cards.push({
        ...action.payload,
        profileUrl: toAbsoluteProfileUrl(action.payload.profileUrl) ?? '',
        id: `noti_${notiIdCounter}`,
        timestamp: Date.now(),
      });
    },

    removeCard(state, action: PayloadAction<string>) {
      state.cards = state.cards.filter((c) => c.id !== action.payload);
    },

    removeCardsByType(state, action: PayloadAction<NotiCardType>) {
      state.cards = state.cards.filter((c) => c.type !== action.payload);
    },

    removeCardsByUserId(state, action: PayloadAction<{ type: NotiCardType; userId: string }>) {
      const { type, userId } = action.payload;
      state.cards = state.cards.filter((c) => !(c.type === type && c.userId === userId));
    },

    reset() {
      return initialState;
    },
  },
});

export const notificationActions = notificationSlice.actions;
export default notificationSlice.reducer;
